<template>
  <div
    class="tab-pane fade"
    id="alamat"
    role="tabpanel"
    aria-labelledby="alamat-tab"
  >
    <form>
      <h5 class="text-center">LOKASI TOKO (BERDASARKAN GOOGLE MAP)*</h5>
      <div class="form-group">
        <label for="inputAddress"
          >Posisi Toko berdasarkan (Google Map)* :</label
        >
        <!-- <input type="text" class="form-control" id="inputAddress" placeholder="1234 Main St"
          :value="user.location.address" /> -->
        <gmap-autocomplete
          class="introInput form-control"
          @place_changed="setPlace"
        >
          <template v-slot:input="slotProps">
            <v-text-field
              outlined
              prepend-inner-icon="place"
              placeholder="Location Of Event"
              ref="input"
              v-on:listeners="slotProps.listeners"
              v-on:attrs="slotProps.attrs"
            >
            </v-text-field>
          </template>
        </gmap-autocomplete>
        <div class="text-center">
          <button
            class="btn btn-dark"
            type="button"
            @click="locatorButtonPressed"
          >
            Lokasi Sekarang
          </button>
        </div>
      </div>
      <div class="form-group">
        <label for="inputAddress"
          >Cari alamat berdasarkan GoogleMap atau Drag Point Merah di Map*
          :</label
        >
      </div>
      <h5 class="text-center">LOKASI TOKO (BERDASARKAN NPWP)*</h5>
      <GmapMap
        ref="mapRef"
        :center="center"
        :zoom="17"
        map-type-id="terrain"
        style="width: 100%; height: 500px"
      >
        <GmapMarker
          v-for="(m, index) in markers"
          :key="index"
          :position="center"
          :clickable="true"
          :draggable="true"
          @click="center = m.position"
          @dragend="showLocation"
        />
      </GmapMap>
      <div class="form-group mt-2">
        <label for="inputAddress2">Alamat Detail NPWP* :</label>
        <input
          type="text"
          class="form-control"
          v-model="user.location.npwpAddress"
          id="inputAddress2"
          placeholder="Apartment, studio, or floor"
        />
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="inputState">Provinsi*</label>
          <select
            required
            id="provinceVal"
            name="provinceVal"
            class="form-control"
            v-model="renderCity"
          >
            <!-- <option selected disabled>Pilih Provinsi</option> -->
            <option
              :value="prov.province_id"
              v-for="(prov, index) in province"
              :key="index"
            >
              {{ prov.province }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="inputState">Kota/Kabupaten* 061800</label>
          <select
            required
            id="cityVal"
            name="cityVal"
            class="form-control"
            v-model="renderKecamatan"
          >
            <!-- <option disabled selected>Pilih Kota</option> -->
            <option
              :value="city.city_id"
              v-for="(city, index) in valCity"
              :key="index"
            >
              {{ city.city_name }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="inputState">Kecamatan* 061804</label>
          <select
            required
            id="kecamatanVal"
            class="form-control"
            name="kecamatanVal"
            v-model="renderKelurahan"
          >
            <!-- <option disabled selected value="">Pilih Kecamatan</option> -->
            <option
              :value="kec.subdistrict_kd"
              :data="kec.subdistrict_id"
              v-for="(kec, index) in valKecamatan"
              :key="index"
            >
              {{ kec.subdistrict }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="inputState">Kelurahan*</label>
          <select
            required
            id="kelurahanVal"
            class="form-control"
            name="kelurahanVal"
          >
            <option disabled selected>Pilih Kelurahan</option>
            <option
              :value="kel.kd_kelurahan_desa"
              :data="kel.kd_kelurahan_desa"
              v-for="(kel, index) in valKelurahan"
              :key="index"
            >
              {{ kel.kelurahan_desa }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="postalCode">Kode Pos :</label>
          <input
            :value="user.location.postalCode"
            type="text"
            class="form-control"
            id="postalCode"
          />
        </div>
      </div>
      <div class="text-center my-3">
        <button @click="updateLocation" type="button" class="btn btn-primary">
          {{ loading ? "" : "Update Lokasi Toko" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { gmapApi } from "vue2-google-maps";
import axios from "axios";
import $ from "jquery";

export default {
  data() {
    return {
      loading: false,
      province: [],
      bankArr: [],
      renderCity: "",
      valCity: [],
      renderKecamatan: "",
      valKecamatan: [],
      renderKelurahan: "",
      valKelurahan: [],
      center: {
        lat: -6.3201981,
        lng: 106.8711803,
      },
      markers: [
        {
          position: {
            lat: -6.3201981,
            lng: 106.8711803,
          },
        },
      ],
      places: [],
      latLng: {},
      isAgree: false,
      locations: [],
      formatedAddresses: [],
      locatorLat: "",
      locatorLng: "",
    };
  },
  computed: {
    google: gmapApi,
    ...mapGetters({
      user: "user",
    }),
  },
  watch: {
    renderCity() {
      this.getCity();
    },
    renderKecamatan() {
      this.getKecamatan();
    },
    renderKelurahan() {
      this.getKelurahan();
    },
  },
  created() {
    setTimeout(() => {
      this.renderCity = this.user.location.province.id;
    }, 200);

    setTimeout(() => {
      this.renderKecamatan = this.user.location.city.id;
    }, 400);

    setTimeout(() => {
      let val = this.user.location.district.code;
      this.renderKelurahan = val;
    }, 600);

    setTimeout(() => {
      var valKel = this.user.location.subdistrict.code;
      // console.log(valKel, "016202AD");
      $(`#kelurahanVal option[value=${valKel}]`).prop("selected", true);
      // $("#kecamatanVal").val(valKel);
    }, 1000);

    this.center.lat = Number(this.user.location.latitude);
    this.center.lng = Number(this.user.location.longitude);
    this.geocodedAddress(
      this.user.location.latitude,
      this.user.location.longitude
    );
  },
  mounted: function() {
    // let lats = Number(this.user.location.latitude);
    // let lngs = Number(this.user.location.longitude);
    // this.$refs.mapRef.$mapPromise.then((map) => {
    //   map.panTo({
    //     lat: Number(lats),
    //     lng: Number(lngs),
    //   });
    // });
    this.getProvince();
  },
  methods: {
    updateLocation() {
      if ($("#inputAddress2").val() === "") {
        this.$toast.error(`Alamat berdasarkan NPWP tidak boleh kosong`);
      } else if ($("#provinceVal").val() === null) {
        this.$toast.error(`Silahkan pilih Provinsi`);
      } else if ($("#cityVal").val() === null) {
        this.$toast.error(`Silahkan pilih Kota`);
      } else if ($("#kecamatanVal").val() === null) {
        this.$toast.error(`Silahkan pilih Kecamatan`);
      } else if ($("#kelurahanVal").val() === null) {
        this.$toast.error(`Silahkan pilih Kelurahan`);
      } else if ($("#postalCode").val() === "") {
        this.$toast.error(`Silahkan pilih Kode Pos`);
      } else {
        const indexForKecamatan = document.getElementById("kecamatanVal")
          .selectedIndex;
        const resForKecVal = document.getElementById("kecamatanVal").options[
          indexForKecamatan
        ].attributes.data.value;

        const setting = {
          title: `<span style="font-size:20px;">Anda yakin?</span>`,
          html: `Anda yakin ingin mengubah alamat?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#C8CBCF",
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
        };
        this.$swal.fire(setting).then((result) => {
          if (result.isConfirmed) {
            this.loading = true;

            axios
              .put("seller/setting/address", {
                address: document.getElementsByClassName("introInput")[0].value,
                latitude: this.center.lat,
                longitude: this.center.lng,
                npwpAddress: document.getElementById("inputAddress2").value,
                provinceId: document.getElementById("provinceVal").value,
                cityId: document.getElementById("cityVal").value,
                districtId: resForKecVal,
                subDistrictCode: document.getElementById("kelurahanVal").value,
                postalCode: document.getElementById("postalCode").value,
              })
              .then(() => {
                this.$store.dispatch("get_user");
                this.$toast.success("Anda berhasil update alamat");
              })
              .finally(() => {
                this.loading = false; // Kembalikan loading ke false setelah selesai
              });
          } else {
            this.loading = false; // Pastikan loading kembali ke false jika dibatalkan
          }
        });
      }
    },
    locatorButtonPressed() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.geocodedAddress(
            position.coords.latitude,
            position.coords.longitude
          );
          this.center.lat = position.coords.latitude;
          this.center.lng = position.coords.longitude;
          // this.markers[0].position.lat = position.coords.latitude
          // this.markers[0].position.lng = position.coords.longitude
          // this.locatorLat = position.coords.latitude
          // this.locatorLng = position.coords.longitude
        },
        (error) => {
          console.log(error.message);
        }
      );
    },
    setPlaceText(place) {
      this.place = place;
    },
    setPlace(place) {
      this.center.lat = place.geometry.location.lat();
      this.center.lng = place.geometry.location.lng();
      this.latLng = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
    },
    geocodedAddress(lat, lon) {
      $.getJSON(
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          lat +
          "," +
          lon +
          "&sensor=false&key=AIzaSyB4C8a6rkM6BKu1W0owWvStPzGHoc4ZBXI",
        function(data) {
          var adress = data.results[0].formatted_address;
          $(".introInput ").val(adress);
        }
      );
    },
    showLocation(evt) {
      this.locatorLat = evt.latLng.lat();
      this.locatorLng = evt.latLng.lng();
      this.center.lat = evt.latLng.lat();
      this.center.lng = evt.latLng.lng();
      this.geocodedAddress(this.locatorLat, this.locatorLng);
    },
    getProvince() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/staging/backendseller/register_penyedia_api/reg3`
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          this.province = data.prov;
          this.bankArr = data.bank;
        });
    },
    getCity() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/staging/backendseller/register_penyedia_api/getCity/${this.renderCity}?ids=${this.renderCity}`
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          this.renderKelurahan = "";
          this.valCity = data;
        });
    },
    getKecamatan() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/staging/backendseller/register_penyedia_api/getKecamatan/${this.renderKecamatan}?ids=${this.renderKecamatan}`
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          // console.log(data);
          this.valKecamatan = data;
        });
    },
    getKelurahan() {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "ci_session=6atpcf73eddl9rq27vtac897i8rc4goc");

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        `https://siplah.eurekabookhouse.co.id/staging/backendseller/register_penyedia_api/getKelurahan/${this.renderKelurahan}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          this.valKelurahan = result;
        })
        .catch((error) => console.log("error", error));
    },
    changeMapMarker() {
      this.center = {
        lat: 10,
        lng: 10,
      };
    },
  },
};
</script>

<style scoped>
/* Set the size of the div element that contains the map */
#map {
  height: 400px;
  /* The height is 400 pixels */
  width: 100%;
  /* The width is the width of the web page */
}
</style>
